// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"src-components-Card-index___cardContainer","title":"src-components-Card-index___title","values":"src-components-Card-index___values"};